import Services from '../components/Services'

export default function ServicesPage() {
  return (
    <main className="min-h-screen">
      {/* Page Header */}
      <section className="gradient-bg text-white py-16">
        <div className="section-container">
          <h1 className="text-4xl md:text-5xl font-display font-bold mb-4">
            Our Services
          </h1>
          <p className="text-lg md:text-xl text-neutral-100 max-w-3xl">
            Comprehensive trading solutions for individuals, institutions, and algorithmic traders
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <Services />

      {/* Features Comparison */}
      <section className="py-16 bg-neutral">
        <div className="section-container">
          <h2 className="section-title text-center mb-12">Account Types Comparison</h2>
          
          <div className="overflow-x-auto">
            <table className="w-full bg-white rounded-lg overflow-hidden">
              <thead className="bg-primary text-white">
                <tr>
                  <th className="px-6 py-4 text-left">Feature</th>
                  <th className="px-6 py-4 text-center">Retail</th>
                  <th className="px-6 py-4 text-center">Professional</th>
                  <th className="px-6 py-4 text-center">Institutional</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-neutral-200">
                <tr>
                  <td className="px-6 py-4 font-semibold text-neutral-700">Commission</td>
                  <td className="px-6 py-4 text-center">$0</td>
                  <td className="px-6 py-4 text-center">From $2.50</td>
                  <td className="px-6 py-4 text-center">Custom</td>
                </tr>
                <tr className="bg-neutral-50">
                  <td className="px-6 py-4 font-semibold text-neutral-700">API Access</td>
                  <td className="px-6 py-4 text-center">REST</td>
                  <td className="px-6 py-4 text-center">REST + WebSocket</td>
                  <td className="px-6 py-4 text-center">FIX Protocol</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 font-semibold text-neutral-700">Execution Speed</td>
                  <td className="px-6 py-4 text-center">Standard</td>
                  <td className="px-6 py-4 text-center">Priority</td>
                  <td className="px-6 py-4 text-center">Ultra-Low Latency</td>
                </tr>
                <tr className="bg-neutral-50">
                  <td className="px-6 py-4 font-semibold text-neutral-700">Support</td>
                  <td className="px-6 py-4 text-center">Email</td>
                  <td className="px-6 py-4 text-center">Priority Phone</td>
                  <td className="px-6 py-4 text-center">Dedicated Manager</td>
                </tr>
                <tr>
                  <td className="px-6 py-4 font-semibold text-neutral-700">Minimum Deposit</td>
                  <td className="px-6 py-4 text-center">$100</td>
                  <td className="px-6 py-4 text-center">$10,000</td>
                  <td className="px-6 py-4 text-center">$1,000,000</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="section-container text-center">
          <h2 className="section-title mb-4">Ready to Get Started?</h2>
          <p className="section-subtitle mx-auto mb-8">
            Choose the account type that fits your trading style and goals
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="btn-primary text-lg">Open Account</button>
            <button className="btn-secondary text-lg">Schedule Demo</button>
          </div>
        </div>
      </section>
    </main>
  )
}

